var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCoinDollar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 25",
    className: "coin-dollar_svg__svg-icon"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 20.992a8 8 0 100-16 8 8 0 000 16zm0 2c5.523 0 10-4.477 10-10s-4.477-10-10-10-10 4.477-10 10 4.477 10 10 10z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 7.992a1 1 0 112 0 3 3 0 013 3 1 1 0 11-2 0 1 1 0 00-1-1h-2.257a.743.743 0 00-.235 1.448l3.616 1.206a2.743 2.743 0 01-.867 5.346H13a1 1 0 11-2 0 3 3 0 01-3-3 1 1 0 112 0 1 1 0 001 1h2.257a.743.743 0 00.235-1.449l-3.616-1.205a2.743 2.743 0 01.867-5.346H11z",
    fill: "currentColor"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNSIgY2xhc3M9InN2Zy1pY29uIj48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTEyIDIwLjk5MmE4IDggMCAxMDAtMTYgOCA4IDAgMDAwIDE2em0wIDJjNS41MjMgMCAxMC00LjQ3NyAxMC0xMHMtNC40NzctMTAtMTAtMTAtMTAgNC40NzctMTAgMTAgNC40NzcgMTAgMTAgMTB6IiBmaWxsPSJjdXJyZW50Q29sb3IiLz48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTExIDcuOTkyYTEgMSAwIDExMiAwIDMgMyAwIDAxMyAzIDEgMSAwIDExLTIgMCAxIDEgMCAwMC0xLTFoLTIuMjU3YS43NDMuNzQzIDAgMDAtLjIzNSAxLjQ0OGwzLjYxNiAxLjIwNmEyLjc0MyAyLjc0MyAwIDAxLS44NjcgNS4zNDZIMTNhMSAxIDAgMTEtMiAwIDMgMyAwIDAxLTMtMyAxIDEgMCAxMTIgMCAxIDEgMCAwMDEgMWgyLjI1N2EuNzQzLjc0MyAwIDAwLjIzNS0xLjQ0OWwtMy42MTYtMS4yMDVhMi43NDMgMi43NDMgMCAwMS44NjctNS4zNDZIMTF6IiBmaWxsPSJjdXJyZW50Q29sb3IiLz48L3N2Zz4=";
export { SvgCoinDollar as ReactComponent };